module.exports = __webpack_public_path__ + "img/additional-savings-grid-toyota-button.fada5119.gif";